import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: [
    '../shared/customer-area.scss',
    './profile.component.scss'
  ]
})
export class ProfileComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
